import React from "react";

/** Map fit score 0–100 to a solid color: 0 red, 100 green. */
function fitScoreStrokeColor(pct) {
  const t = Math.min(Math.max(pct, 0), 100) / 100;
  const hue = t * 120;
  return `hsl(${hue}, 72%, 46%)`;
}

/**
 * Fit score 0–100 with a progress ring in one color from the score (not a multi-stop gradient).
 */
const FitScoreRadial = ({ score }) => {
  const pct = Math.min(Math.max(Number(score) || 0, 0), 100);
  const r = 15;
  const stroke = 3;
  const size = 40;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  const arcColor = fitScoreStrokeColor(pct);

  return (
    <div className="relative flex h-10 w-10 flex-shrink-0 items-center justify-center" title={`Fit ${pct}`}>
      <svg
        className="absolute inset-0 -rotate-90"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        aria-hidden
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="transparent"
          stroke="currentColor"
          strokeWidth={stroke}
          className="text-theme-main opacity-90"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="transparent"
          stroke={arcColor}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
        />
      </svg>
      <span className="relative z-10 text-xs font-medium tabular-nums text-theme-text">{Math.round(pct)}</span>
    </div>
  );
};

export default FitScoreRadial;
